import { render, staticRenderFns } from "./videoCard.vue?vue&type=template&id=5a9ed83c&scoped=true&"
import script from "./videoCard.vue?vue&type=script&lang=js&"
export * from "./videoCard.vue?vue&type=script&lang=js&"
import style0 from "./videoCard.vue?vue&type=style&index=0&id=5a9ed83c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9ed83c",
  null
  
)

export default component.exports